/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export interface IPromoBannerText {
    text: string;
    requestContext: Msdyn365.IRequestContext;
    onTextChange(event: Msdyn365.ContentEditableEvent): void;
}

export const PromoBannerText: React.FC<IPromoBannerText> = ({ text, onTextChange, requestContext }) => {
    return(
        <Msdyn365.Text
            className='ms-promo-banner__text'
            tag={'span'}
            text={text}
            editProps = {{onEdit: onTextChange, requestContext: requestContext}}
        />
    );
};